import LangEnum from '../../../../../../../lang/LangEnum';
import { isPreOrder } from '../../../../../../products/utils/availability.utils';
import { OfflineOrderProduct } from '../../../orderProduct/OfflineOrderProduct';
import {
  OfflineOrderRulesReturnMap,
  OfflineOrderRulesTo,
  ValidateOfflineOrderRuleParams,
} from '../../OfflineOrderRules.types';
import BaseOrderProductQuantityRule from '../baseOrderProductQuantity.rule';

export default class PreOrderMultipleAmountByProductRule extends BaseOrderProductQuantityRule {
  validate({
    order,
    userRole,
  }: ValidateOfflineOrderRuleParams): OfflineOrderRulesReturnMap[OfflineOrderRulesTo.VALIDATE_PRODUCTS] {
    if (this.canUserBypassRule(userRole)) {
      return { hasErrors: false };
    }

    const filtered = this.filterOrderProducts(order.products ?? []);
    const grouped = this.groupOrderProductsByProductId(filtered);

    Object.values(grouped).forEach((orderProducts) => {
      this.validateOrderProducts(orderProducts);
    });

    if (!this.orderProductsWithError.length) {
      return {
        hasErrors: false,
      };
    }

    return {
      hasErrors: true,
      error: { messageCode: LangEnum.ORDER_PRODUCT_RULE_PRE_ORDER_MULTIPLE_AMOUNT_BY_PRODUCT },
      orderProductsWithError: this.orderProductsWithError,
    };
  }

  private filterOrderProducts(products: OfflineOrderProduct[]): OfflineOrderProduct[] {
    return products.filter(
      (orderProduct) =>
        isPreOrder(orderProduct.availability) &&
        !!orderProduct.product.rules?.preOrderMultipleProduct,
    );
  }

  private validateOrderProducts(orderProducts: OfflineOrderProduct[]) {
    const quantity = this.getOrderProductsTotalQuantity(orderProducts);
    const multiple = orderProducts[0].product.rules?.preOrderMultipleProduct ?? 0;
    const isMultiple = this.validateMultipleOf(quantity, multiple);

    if (!isMultiple) {
      this.pushAllProductsWithError(orderProducts, {
        minimumQuantity: multiple,
      });
    }
  }
}
